import Vue from 'vue';

const d = (obj) => {
  console.log(JSON.stringify(obj, null, 4));
};

const plugin = {
  install() {
    Vue.helpers = { d };
    Vue.prototype.$helpers = { d };
  },
};

export default plugin;
